import { Mail, UserRound, CreditCard, Star, Heart, MessageCircle, ShieldCheck, Trash2 } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import { FadeUp } from "@/components/Reveal";
import { EMAILS } from "@/config";

const TOPICS = [
  { icon: UserRound, title: "Hesap ve Giriş", text: "Giriş sorunları, profil bilgileri ve hesap ayarları." },
  { icon: CreditCard, title: "Üyelik ve Abonelik", text: "Abonelik durumu, yenileme ve App Store üzerinden yönetim." },
  { icon: Star, title: "The Five", text: "Günlük seçkiler ve eşleşme tercihlerin hakkında sorular." },
  { icon: Heart, title: "My Date", text: "My Date istekleri ve karşılıklı eşleşme süreci." },
  { icon: MessageCircle, title: "Mesajlaşma", text: "Eşleşme sonrası iletişim ve mesajlaşma deneyimi." },
  { icon: ShieldCheck, title: "Güvenlik ve Bildirim", text: "Uygunsuz davranış bildirimi ve güvenlik konuları." },
  { icon: Trash2, title: "Hesap Silme", text: "Hesabını ve verilerini silme süreci hakkında destek." },
];

export default function SupportPage() {
  return (
    <>
      <PageHeader silk={1}
        testid="support-header"
        eyebrow="Destek"
        titleLines={["Five Star", "Destek."]}
        lede="Five Star ile ilgili soruların, üyelik işlemleri veya teknik destek için bizimle iletişime geçebilirsin."
      />
      <section className="bg-ivory pb-24 sm:pb-32 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {TOPICS.map((t, i) => (
              <FadeUp key={t.title} delay={i * 0.06}>
                <a
                  href={`mailto:${EMAILS.support}?subject=${encodeURIComponent(t.title)}`}
                  data-testid={`support-topic-${i}`}
                  className="block h-full bg-white/90 border border-burgundy/10 rounded-[6px] p-7 hover:border-burgundy/30 hover:-translate-y-1 transition-all duration-300 group"
                >
                  <span className="w-10 h-10 rounded-full border border-gold/50 flex items-center justify-center">
                    <t.icon className="w-[18px] h-[18px] text-burgundy" aria-hidden="true" />
                  </span>
                  <h2 className="mt-5 font-serif text-xl text-ink group-hover:text-burgundy transition-colors">
                    {t.title}
                  </h2>
                  <p className="mt-2 text-sm font-light text-ink-soft/90 leading-relaxed">{t.text}</p>
                </a>
              </FadeUp>
            ))}
          </div>

          <FadeUp delay={0.2} className="mt-16 bg-burgundy-tint/60 border border-burgundy/10 rounded-[6px] p-8 sm:p-12 text-center">
            <h2 className="font-serif text-2xl sm:text-3xl text-ink">Destek ekibimiz yanında.</h2>
            <p className="mt-3 max-w-md mx-auto text-[15px] font-light text-ink-soft/90 leading-relaxed">
              Destek taleplerine mümkün olan en kısa sürede dönüş yapılır.
            </p>
            <a
              href={`mailto:${EMAILS.support}`}
              data-testid="support-mailto-button"
              className="mt-8 inline-flex items-center gap-2.5 px-7 py-3.5 rounded-[3px] text-sm font-sans font-medium tracking-wide bg-burgundy text-ivory-light border border-burgundy hover:bg-burgundy-hover hover:shadow-[0_10px_24px_rgba(110,22,51,0.22)] transition-all duration-300"
            >
              <Mail className="w-4 h-4" aria-hidden="true" />
              Destek Ekibine Yaz
            </a>
            <p className="mt-5 text-xs text-ink-muted tracking-wide">{EMAILS.support}</p>
          </FadeUp>
        </div>
      </section>
    </>
  );
}
